import ContentLoader from "react-content-loader";
import React from "react";
const ChatListItemLoader = () => {
  return (
    <div className="chat-list-item-loader">
      <ContentLoader
        speed={2}
        width={284}
        height={70}
        viewBox="0 -8 284 70"
        backgroundColor="#272727"
        foregroundColor="#5e5e5e"
      >
        <rect x="64" y="30" rx="3" ry="3" width="52" height="6" />
        <circle cx="27" cy="27" r="27" />
        <rect x="64" y="12" rx="3" ry="3" width="139" height="6" />
      </ContentLoader>
    </div>
  );
};

export default ChatListItemLoader;
